import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Grid, useTheme } from '@mui/material'
import React from 'react'
import { Chip } from 'src/Components'
import { SettingsBox } from 'src/Elements/Data'
import { IslandDetectionSettingsModel } from '../types/grid-and-system-protection.model'

const NAME_SPACE = 'systemSettings.grid-and-system-protection-configuration.island-network-detection'

type Props = {
  islandDetectionSettingsModel: IslandDetectionSettingsModel
}

const IslandNetworkDetectionSettings: React.FC<Props> = ({ islandDetectionSettingsModel }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()

  return (
    <Grid item xs={12}>
      <AccordionItem title={t(`${NAME_SPACE}.title`)} expanded>
        <Box sx={{ padding: [2, 4] }}>
          <SettingsBox
            title={t(`${NAME_SPACE}.used-mode.title`)}
            suffix={
              <Box py={1}>
                <Chip
                  paletteColor={theme.palette.primary}
                  textKey={t(`${NAME_SPACE}.used-mode.chip.${islandDetectionSettingsModel.value}`)}
                  isLoading={false}
                />
              </Box>
            }
          />
        </Box>
      </AccordionItem>
    </Grid>
  )
}
export default IslandNetworkDetectionSettings
